import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Users',
    data () {
        return {
            admin:{},
            cnservices:{},
            cnpay_charges:{},
            cnpay_commissions:{},
            cnpay_charge:{},
            cnpay_commission:{},
            plans:{},
            plan:{},
            service_charges: {},
            service_charge: {},
            default_charges: {},
            default_charge: {},
            wallet_charges:{},
            wallet_charge:{},
            services_rewards:{},
            service_reward:{},
            panelFlag: "",
            disable_btn: false,
            loading:false,
            img_url: service.imageURL,
            resetPasswordPanel:false,
            resetEmailPanel:false,
            editCnpayCharge:false,
            editCnpayComm:false,
            editPlans:false,
            editServiceCharge:false,
            editDefaultCharge:false,
            mod_message: "",
            editWalletCharge: false,
            addWalletCharge: false,
            editServiceReward:false,
            addServiceReward: false,
            new_wallet_charge_entry_min: 0,
            min_wallet_topup_amount:0,
            max_wallet_topup_amount:0,
            wallet_entry_error:false,
            wallet_entry_amt_error:false,
            service_reward_type:"P",
            service_reward_activation_status:1,
            paga_service_reward_type:"P",
            paga_service_reward_activation_status:1,
            service_reward_error:"",
            paga_merchants:{},
            paga_mobile_operators:{},
            paga_service_groups:{},
            paga_service_group:{},
            paga_service_group_merchant:{},
            paga_service_error:"",
            paga_available_balance:0,
            paga_merchant_dnds:{},
            commission_type: 'p',
            addPagaServiceGroup:false,
            addPagaServiceGroupMerchant:false,
            editPagaServiceGroup:false,
            deletePagaServiceGroup:false,
            editPagaServiceGroupMerchant:false,
            deletePagaServiceGroupMerchant:false,
            has_paga_service_group_for_mobile_operator:true,

            paga_test_dump1:{},
            paga_test_dump2:{},
            today: new Date(),
            //
            component_view:{},
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    computed:{
        var1() {return parseInt(this.cnpay_charge.cnpay_chg_range1_max)+1;},
        var2() {return parseInt(this.cnpay_charge.cnpay_chg_range2_max)+1;}
    },
    methods: {
        //settings
        setComponentView(view,attr1,attr2){
            this.component_view = {};
            this.component_view[view] = true;
        },

        setComponent(attr,attr2) {
            this.panelFlag = true;
            if(attr == "reset-password"){
                this.resetPasswordPanel = true;
            }

            if(attr == "reset-email"){
                this.resetEmailPanel = true;
            }

            if(attr == "edit-cnpay-charge"){
                this.editCnpayCharge = true;
                this.cnpay_charge = attr2;
            }

            if(attr == "edit-cnpay-comm"){
                this.editCnpayComm = true;
                this.cnpay_commission = attr2;
            }

            if(attr == "edit-service-charge"){
                this.editServiceCharge = true;
                this.service_charge = attr2;
            }

            if(attr == "edit-default-charge"){
                this.editDefaultCharge = true;
                this.default_charge = attr2;
            }

            if(attr == "edit-plan"){
                this.editPlans = true;
                this.plan = attr2;
            }

            if(attr == "add-wallet-charge"){
                this.addWalletCharge = true;
                if((this.wallet_charges.length == undefined) || (this.wallet_charges.length == 0)){
                    this.new_wallet_charge_entry_min = this.min_wallet_topup_amount; //set to deafult min for first entry
                }
                else{
                    this.new_wallet_charge_entry_min = (this.wallet_charges[this.wallet_charges.length-1].wallet_charge_max + 1); //eg 3000 + 1 = 3001
                }
                
            }

            if(attr == "edit-wallet-charge"){
                this.wallet_charge.set_edit = false;
                this.editWalletCharge = true;
                this.wallet_charge = attr2;
                this.wallet_charge.set_edit = true;
            }

            if(attr == "delete-wallet-charge"){
                this.wallet_charge = attr2;
                this.deleteWalletProcessingCharge();
            }

            if(attr == "add-service-reward"){
                this.addServiceReward = true;
            }

            if(attr == "edit-service-reward"){
                this.service_reward = attr2;
                this.service_reward_type = this.service_reward.service_reward_type;
                this.service_reward_activation_status = this.service_reward.service_reward_activation_status;
                this.editServiceReward = true;
            }

            if(attr == "delete-service-reward"){
                this.service_reward = attr2;
                this.deleteServiceRewards();
            }

            if(attr == "add-paga-service-group"){
                this.addPagaServiceGroup = true;
            }

            if(attr == "edit-paga-service-group"){
                this.paga_service_group = attr2;
                this.editPagaServiceGroup = true;
            }

            if(attr == "delete-paga-service-group"){
                this.paga_service_group = attr2;
                this.deletePagaServiceGroup = true;
                // this.deletePagaServiceGroups();
            }

            if(attr == 'add-paga-service-group-merchant'){
                this.paga_service_group = attr2; //the service_group
                this.addPagaServiceGroupMerchant = true;
            }

            if(attr == "edit-paga-service-group-merchant"){
                this.paga_service_group_merchant = attr2;
                this.commission_type = this.paga_service_group_merchant.paga_service_group_merchant_commission_type;
                this.paga_service_reward_type = this.paga_service_group_merchant.paga_service_group_merchant_reward_type;
                this.paga_service_reward_activation_status = this.paga_service_group_merchant.paga_service_group_merchant_reward_activation_status;
                this.editPagaServiceGroupMerchant = true;
            }

            if(attr == "delete-paga-service-group-merchant"){
                this.paga_service_group_merchant = attr2;
                this.deletePagaServiceGroupMerchant = true;
              //  this.deletePagaServiceGroupMerchants();
            }

            if(attr == "reset-action"){
                this.resetPasswordPanel = false;
                this.resetEmailPanel = false;
                this.editCnpayComm = false;
                this.editCnpayCharge = false;
                this.editServiceCharge = false;
                this.editPlans = false;
                this.editWalletCharge = false;
                this.addWalletCharge  =  false;
                this.editDefaultCharge = false;
                this.addServiceReward = false;
                this.editServiceReward = false;
                this.addPagaServiceGroup = false;
                this.addPagaServiceGroupMerchant = false;
                this.editPagaServiceGroup = false;
                this.editPagaServiceGroupMerchant = false;
                this.deletePagaServiceGroupMerchant = false;
                this.paga_service_error = "";
            }
        },
        requests(req){
            if(req == "delete"){ this.deleteRequest = true;}
            if(req == "edit"){ this.editRequest = true;}
            if(req == "reset"){ this.editRequest = false; this.deleteRequest = false;}
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        resetPassword() {
            this.loading = true;
            var credentials = {
                user_current_password: this.admin.current_password,
                user_new_password: this.admin.new_password,
                user: this.admin.user_id
            }
            let navi = this.$router;
            if(credentials.user_current_password == '' || credentials.user_new_password == '' ) {
               toastr.warning("Kindly enter password", 'Warning!');
               this.loading = false;
            }else if(credentials.user_current_password == null || credentials.user_new_password == null) {
                toastr.warning("Kindly enter password", 'Warning!');
                this.loading = false;
             }else {
                service.resetPassword(this, credentials).then((response) => {
                    if(response.body.status == 200) {
                         navi.push('/login');   
                    }else{
                        this.mod_message = response.body.message;
                    }
                    this.loading = false;
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                        this.mod_message = "invalid credentials";
                    }
                    this.loading = false;
                })
            }
        },

        resetEmail() {
            this.loading = true;
            var credentials = {
                current_email: this.admin.current_email,
                new_email: this.admin.new_email,
                user: this.admin.user_id,
            }
            let navi = this.$router;
            if(credentials.current_email == null || credentials.current_email == undefined || credentials.current_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else if(credentials.new_email == null || credentials.new_email == undefined || credentials.new_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else {
                service.resetEmail(this, credentials).then((response) => {
                    if(response.body.status == 200) {
                        navi.push('/login');   
                   }else{
                       this.mod_message = response.body.message;
                   }
                   this.loading = false;
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                        this.mod_message = response.body.message;
                    }
                    this.mod_message = "invalid credentials";
                    this.loading = false;
                })
            }
        },

        //get all saved listings
        getCNpayCharges() {
            service.getCNpayCharges(this).then(data => {
               if(data.body.status == 200) {
                    this.cnpay_charges = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //get commisions
        getCNpayCommisions() {
            service.getCNpayCommissions(this).then(data => {
               if(data.body.status == 200) {
                    this.cnpay_commissions = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //get plans
        getPaymentPlans() {
            service.getPaymentPlans(this).then(data => {
               if(data.body.status == 200) {
                    this.plans = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

         //get service charges
         getServiceCharges() {
            service.getServiceCharges(this).then(data => {
               if(data.body.status == 200) {
                    this.service_charges = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getDefaultCharges() {
            service.getDefaultCharges(this).then(data => {
               if(data.body.status == 200) {
                    this.default_charges = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editCnpayCharges(){
            service.editCnpayCharges(this, this.cnpay_charge.cnpay_chg_id, this.cnpay_charge).then(data => {
               if(data.body.status == 200) {
                   // this.cnpay_charges = data.body.data;
                   this.getCNpayCharges();
                    this.editCnpayCharge = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editCnpayCommissions(){
            service.editCnpayCommissions(this, this.cnpay_commission.cnpay_comm_id, this.cnpay_commission).then(data => {
               if(data.body.status == 200) {
                   // this.cnpay_charges = data.body.data;
                   this.getCNpayCommisions();
                    this.editCnpayComm = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editServiceCharges(){
            service.editServiceCharges(this, this.service_charge.service_id, this.service_charge).then(data => {
               if(data.body.status == 200) {
                    this.getServiceCharges();
                    this.editServiceCharge = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editDefaultCharges(){
            service.editDefaultCharges(this, this.default_charge.charge_id, this.default_charge).then(data => {
                if(data.body.status == 200) {
                    this.getDefaultCharges();
                    this.editDefaultCharge = false;
                }
                this.getWalletProcessingCharges(); //to reset esp if wallet topup minimum was edited
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editPlansAndPricing(){
            service.editPlansAndPricing(this, this.plan.plan_id, this.plan).then(data => {
               if(data.body.status == 200) {
                   // this.cnpay_charges = data.body.data;
                   this.getPaymentPlans();
                    this.editPlans = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //...wallets
        //get wallet processing charges
        getWalletProcessingCharges() {
            service.getWalletProcessingCharges(this).then(data => {
                this.wallet_charges = data.body.data;
                
                if(data.body.status == 200) {
                    //set can_delete for only last row
                    this.wallet_charges[this.wallet_charges.length-1].can_delete_entry = true;
                }

                this.min_wallet_topup_amount = data.body.data_min_wallet_topup_amount; //already set min balance
                this.max_wallet_topup_amount = data.body.data_max_wallet_topup_amount;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },


        addProcessingCharge(){
           //check if entry is valid ie. is a number not less than all other max
            //function every.... the_array.some(el => el > 3)
            if((this.wallet_charges.length != 0)){ //data available
                let entry_max_value =  parseInt(this.wallet_charge.wallet_charge_max) //resolve input int
                if(this.wallet_charges.some(element => element.wallet_charge_max >= entry_max_value)){
                    this.wallet_entry_error = true;
                }else{
                    this.wallet_entry_error = false;
                } 
                //check amount
                if(this.wallet_charges.some(element => element.wallet_charge_charge >= parseInt(this.wallet_charge.wallet_charge_charge))){
                    this.wallet_entry_amt_error = true;
                }else{
                    this.wallet_entry_amt_error = false; //refresh
                }
            }else{
                if(this.min_wallet_topup_amount >= this.wallet_charge.wallet_charge_max){ 
                    this.wallet_entry_error = true;
                }else{
                    this.wallet_entry_error = false;
                } 
            }
            
            // if((this.wallet_charges.length == undefined) || ((!this.wallet_entry_error) && (!this.wallet_entry_amt_error)) ){
            if((!this.wallet_entry_error) && (!this.wallet_entry_amt_error)){
                var payload = {
                    wallet_charge_min: this.new_wallet_charge_entry_min,
                    wallet_charge_max: this.wallet_charge.wallet_charge_max,
                    wallet_charge_charge: this.wallet_charge.wallet_charge_charge,
                }
                service.addWalletProcessingCharge(this,payload).then(data => {
                    if(data.body.status == 201) {
                         this.wallet_charges = data.body.data;
                         //set can_delete for only last row
                         this.wallet_charges[this.wallet_charges.length-1].can_delete_entry = true;
                         //reset panel
                         this.addWalletCharge = false;
                     }
                 }).catch((err) => {
                     if(err) {
                         toastr.error('Sorry, could not process information', 'Warning!');
                     }
                 })
            }
            this.wallet_charge = {}; 
        },

    
        editWalletProcessingCharge(){
            //check amount
            let charge_index = this.wallet_charges.indexOf(this.wallet_charge);
            let edited_amount = parseInt(this.wallet_charge.wallet_charge_charge);
            let prev_amount  = 0;
            let next_amount  = 0;

            if(charge_index != 0){ //not ist element
                //get prev amount
                prev_amount  = this.wallet_charges[(charge_index-1)].wallet_charge_charge; //will return undefined if first element
            }
            if((this.wallet_charges.indexOf(this.wallet_charges[this.wallet_charges.length-1])) != charge_index){ //not last elemsnt
               //get next amount if available
                next_amount  = this.wallet_charges[(charge_index+1)].wallet_charge_charge; //will return undefined if last element
            }else{
                next_amount = edited_amount+1; //defautly set to help pass check
            }

            //check if edited is less than prev amt or greater than next amt
            if((edited_amount < prev_amount) || (edited_amount > next_amount)){
                this.wallet_entry_amt_error = true;
            }else{
                this.wallet_entry_amt_error = false; //refresh
            }

            if(!this.wallet_entry_amt_error){
                service.editWalletProcessingCharge(this, this.wallet_charge.wallet_charge_id, this.wallet_charge).then(data => {
                    if(data.body.status == 200) {
                        // this.cnpay_charges = data.body.data;
                        this.getWalletProcessingCharges();
                        this.editWalletCharge = false;
                     }
                 }).catch((err) => {
                     if(err) {
                         toastr.error('Sorry, could not process information', 'Warning!');
                     }
                 })
            }
           
        },

        deleteWalletProcessingCharge(){
            service.deleteWalletProcessingCharge(this, this.wallet_charge.wallet_charge_id).then(data => {
               if(data.body.status == 200) {
                   // this.cnpay_charges = data.body.data;
                   this.getWalletProcessingCharges();
                    
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        //..../..wallets

        //....service--rewards
        getCNservices() {
            service.getCNServices(this).then(data => {
                this.cnservices = data.body.data;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getServiceRewards() {
            service.getServiceRewards(this).then(data => {
                this.services_rewards = data.body.data;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        addServiceRewards(){
            this.disable_btn = true;
            var payload = {
                service_service: this.service_reward.service | 0,
                service_reward: this.service_reward.reward,
                service_reward_type: this.service_reward_type || 'P',
                service_reward_status: 1, //activated
            }
           if((payload.service_reward != '') || (payload.service_service != 0)){
                service.addServiceRewards(this,payload).then(data => {
                    if(data.body.status == 201) {
                        this.services_rewards = data.body.data;
                        this.disable_btn = false;
                        this.service_reward = {};
                     }
                     this.addServiceReward = false;
                 }).catch((err) => {
                     if(err.status == 409) {
                         this.service_reward_error = "Service Reward already exists";
                    }
                    toastr.error('Sorry, could not process information', 'Warning!');
                 })
            }else{
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },

    
        editServiceRewards(){
            this.disable_btn = true;
            var payload = {
                service_reward: this.service_reward.service_reward_reward,
                service_reward_type: this.service_reward_type || 'P',
                service_reward_status: this.service_reward_activation_status || 1, //activated
            }
           if((payload.service_reward != '') || (payload.service_service != 0)){
                service.editServiceRewards(this,this.service_reward.service_reward_id,payload).then(data => {
                    if(data.body.status == 200) {
                        this.services_rewards = data.body.data;
                        this.disable_btn = false;
                        this.service_reward = {};
                     }
                     this.editServiceReward = false;
                 }).catch((err) => {
                    toastr.error('Sorry, could not process information', 'Warning!');
                 })
            }else{
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
           
        },

        deleteServiceRewards(){
            service.deleteServiceRewards(this, this.service_reward.service_reward_id).then(data => {
               if(data.body.status == 200) {
                    this.getServiceRewards();
                 }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        //.../...service--rewards

        //.....Paga Services...
        getPagaServicesRemoteXX(){
            var payload = {"referenceNumber":"5618889345117897834344943344889",
            "locale": "", "receiverPhoneNumber": "08059079689", "amount": 100,
            "quantity": 1, "message": "", "identificationType": "",
            "identificationNumber": "", "operatorPublicId": ""}
            // var payload = {
            //     "referenceNumber": "", "customerPrincipal": "+111111111111",
            //     "customerCredentials":"password1", "customerFirstName":"Nzube",
            //     "customerLastName":"Nzube",   "customerDateOfBirth":"01/01/2013",
            //     "accountDetails": ""
            // }
            service.pagaGetMerchants(this).then(response => {
                
            this.paga_test_dump1 = response.body.billers;
            // console.log(response.body.responseCode+"lop")

                // service.postPagaMerchants(this,response.body.billers).then(response => {
                    
                //     console.log(response.body.status); 
                // }).catch((err) => {
                //         this.loading = false;
                //         console.log(4545+"-error")
                //         console.log(err)
                // })

            }).catch((err) => {
                this.loading = false;
                console.log(4545+"-error")
                console.log(err)
            })

            service.pagaGetMobileOperators(this).then(response => {
                
                this.paga_test_dump2 = response;
            }).catch((err) => {
                    this.loading = false;
                    console.log(4545+"-error")
                    console.log(err)
            })
        },

        getPagaServicesRemote(){
            //get Paga merchants
            service.pagaGetMerchants(this).then(response => {
                service.postPagaMerchants(this,response.body.billers).then(response => {
                    //console.log(response.body.status); 
                }).catch((err) => {
                    this.loading = false;
                    //console.log(err)
                })
            }).catch((err) => {
                this.loading = false;
                // console.log(err)
            })

            //get Paga Mobile Operators
            service.pagaGetMobileOperators(this).then(response => {
                service.postPagaMobileOperators(this,response.body.operators).then(response => {
                    //console.log(response.body.status); 
                }).catch((err) => {
                    this.loading = false;
                   // console.log(err)
                })
            }).catch((err) => {
                    this.loading = false;
                    //console.log(err)
            })
        },

        getPagaMerchants() {
            service.getPagaMerchants(this).then(data => {
                this.paga_merchants = data.body.data;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getPagaMobileOperators() {
            service.getPagaMobileOperators(this).then(data => {
                this.paga_mobile_operators = data.body.data;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getPagaServiceGroups() {
            service.getPagaServiceGroups(this).then(data => {
                this.paga_service_groups = data.body.data;
                this.has_paga_service_group_for_mobile_operator = data.body.data_has_paga_service_group_for_mobile_operator;
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        addPagaServiceGroupMobileOperator(){
            this.paga_service_group.group_for = "MOBILEOPS";
            this.addPagaServiceGroups();
            this.has_paga_service_group_for_mobile_operator = true;
        },

        addPagaServiceGroups(){
            this.disable_btn = true;
            var payload = {
                group_name: this.paga_service_group.group_name,
                group_title: this.paga_service_group.group_title || this.paga_service_group.group_name,
                group_for: this.paga_service_group.group_for || "MERCHANT",
            }
           if((payload.group_name != '') || (payload.group_name == undefined)){
                service.addPagaServiceGroups(this,payload).then(data => {
                    if(data.body.status == 201) {
                        this.paga_service_groups = data.body.data;
                        this.disable_btn = false;
                        this.paga_service_group = {};
                        this.paga_service_error = "";
                     }
                     this.addPagaServiceGroup = false;
                 }).catch((err) => {
                    if(err.status == 409) {
                        this.paga_service_error = "Group already exists";
                        toastr.error(this.paga_service_error, 'Warning!');
                    }else{
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                    this.paga_service_group = {};
                    this.disable_btn = false;
                 })
            }else{
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },

    
        editPagaServiceGroups(){
            this.disable_btn = true;
            var payload = {
                group_name: this.paga_service_group.paga_service_group_name,
                group_title: this.paga_service_group.paga_service_group_title || this.paga_service_group.paga_service_group_name,
            }
           if((payload.group_name != '')){
                service.editPagaServiceGroups(this,this.paga_service_group.paga_service_group_id,payload).then(data => {
                    if(data.body.status == 200) {
                        this.paga_service_groups = data.body.data;
                        this.disable_btn = false;
                        this.paga_service_group = {};
                     }
                     this.editPagaServiceGroup = false;
                 }).catch((err) => {
                    if(err.status == 409) {
                        this.paga_service_error = "Group already exists";
                        toastr.error(this.paga_service_error, 'Warning!');
                    }else{
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                 })
            }else{
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
           
        },

        deletePagaServiceGroups(){
            service.deletePagaServiceGroups(this, this.paga_service_group.paga_service_group_id).then(data => {
               if(data.body.status == 200) {
                    this.getPagaServiceGroups();
                 }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        addPagaServiceGroupMerchants(){
            this.disable_btn = true;
            var payload = {
                merchant: this.paga_service_group_merchant.merchant,
                merchant_service_group: this.paga_service_group.paga_service_group_id,
                merchant_service_group_type: this.paga_service_group.paga_service_group_for,
                merchant_commission_type: this.commission_type || 'P',
                merchant_commission: this.paga_service_group_merchant.commission || 0,
                merchant_reward_type: this.paga_service_reward_type || 'P',
                merchant_reward: this.paga_service_group_merchant.reward || 0,
                merchant_reward_activation_status: this.paga_service_reward_activation_status || 1,
                merchant_max_purchase_amount: this.paga_service_group_merchant.max_purchase_amount || 0,
            }
           if((payload.merchant != '') || (payload.merchant_service_group != 0)){
                service.addPagaServiceGroupMerchants(this,payload).then(data => {
                    if(data.body.status == 201) {
                        this.paga_service_group.paga_service_group_merchants = data.body.data;
                        this.disable_btn = false;
                        this.paga_service_group_merchant = {};
                     }
                     this.addPagaServiceGroupMerchant = false;
                 }).catch((err) => {
                     if(err.status == 409) {
                        this.paga_service_error = "Merchant already exists";
                        toastr.error(this.paga_service_error, 'Warning!');
                    }else{
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                    this.paga_service_group_merchant = {};
                    this.disable_btn = false;
                 })
            }else{
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },

    
        editPagaServiceGroupMerchants(){
            this.disable_btn = true;
            var payload = {
                merchant_commission_type: this.commission_type || 'P',
                merchant_commission: this.paga_service_group_merchant.paga_service_group_merchant_commission || 0,
                merchant_reward_type: this.paga_service_reward_type || 'P',
                merchant_reward: this.paga_service_group_merchant.paga_service_group_merchant_reward || 0,
                merchant_reward_activation_status: this.paga_service_reward_activation_status || 1,
                merchant_max_purchase_amount: this.paga_service_group_merchant.paga_service_group_merchant_max_purchase_amount || 0,
            }
           if((payload.merchant_commission != undefined) || (payload.merchant_reward != undefined)){
                service.editPagaServiceGroupMerchants(this,this.paga_service_group_merchant.paga_service_group_merchant_id,payload).then(data => {
                    if(data.body.status == 200) {
                        this.paga_service_groups = data.body.data;
                        this.disable_btn = false;
                        this.paga_service_group_merchant = {};
                     }
                     this.editPagaServiceGroupMerchant = false;
                 }).catch((err) => {
                    //add code with status 400 - no edit made
                    //toastr.error('Sorry, could not process information', 'Warning!');
                    this.disable_btn = false;
                    this.paga_service_group_merchant = {};
                    this.editPagaServiceGroupMerchant = false;
                 })
            }else{
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
           
        },

        deletePagaServiceGroupMerchants(){
            service.deletePagaServiceGroupMerchants(this, this.paga_service_group_merchant.paga_service_group_merchant_id).then(data => {
               if(data.body.status == 200) {
                    this.getPagaServiceGroups();
                 }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        addPagaMerchantDoNotDisplayServices(merchant){
            var payload = {
                service_merchant: merchant,
                service_name: this.paga_merchant_dnds.service_name,
            }
           if((payload.service_merchant != '') || (payload.service_name != 0)){
                service.postPagaMerchantDoNotDisplayServices(this,payload).then(data => {
                    if(data.body.status == 201) {
                        //this.getPagaServiceGroups();
                        this.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display = data.body.data;
                        this.paga_merchant_dnds = {}; //refresh
                    }
                }).catch((err) => {})
            }else{
                toastr.error('Sorry, some fields are empty', 'Warning!');
            }
        },

    

        deletePagaMerchantDoNotDisplayServices(data){
            service.deletePagaMerchantDoNotDisplayServices(this,data.service_id,data.service_merchant).then(data => {
                if(data.body.status == 200) {
                    this.paga_service_group_merchant.paga_service_group_merchant_services_do_not_display = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },


        
        //..... Paga Services...

        onFileChange(e, data) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                formData.append('data_id', data);
                formData.append('data_type', "paga_merchants");   
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        // this.user.user_image = data.body.data;
                        location.reload = true;
                    }
                  }).catch((err) => {
                    if(err) {
                       // log it
                    }
                })
            }   
            
        },

        getPagaBalance() { 
            this.paga_available_balance = "...";
            //let seek_url = service.paga_apiBaseUrl+'secured/getAvailableBalance';
            let seek_url = service.paga_apiBaseUrl+'accountBalance';
            var payload = {
                "referenceNumber":"CNpayPG-"+this.today.getTime(), "locale": ""
            }
            let hash = service.SHA512(payload.referenceNumber + service.paga_apiKey);
            service.getPagaRequest(this,payload,seek_url,hash).then(data => {
                if(data.body.responseCode == 0){
                    this.paga_available_balance = data.body.availableBalance;
                }
            }).catch((err) => {})
        },
    },
    created: function(){
        this.preset();
        this.getCNpayCharges();
        this.getCNpayCommisions();
        this.getPaymentPlans();
        this.getServiceCharges();
        this.getDefaultCharges();
        this.getWalletProcessingCharges();
        this.getServiceRewards();
        this.getCNservices();
        //this.getPagaServicesRemote(); //used @dashboard
        this.getPagaMerchants();
        this.getPagaMobileOperators();
        this.getPagaServiceGroups();
        this.getPagaBalance();
    }
}


// WEBPACK FOOTER //
// ./src/components/Settings/script.js